import { lazy } from "react";
const Abm = lazy(() => import("@/modules/Report/AbmNew"));

const AbmNewRoutes = {
  element: <Abm />,
  path: "abm",
};

export default AbmNewRoutes;
